import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Actions } from '../../enums/ActionEnums';
import { AuthRoutes, RouteNames } from '../../enums/RouteEnums';
import OverviewToolbar from '../Common/Layout/OverviewToolbar';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../AppContext';
import { HomeWork, Info, LocationOn } from '@mui/icons-material';
import { Colors } from '../../utils/theme';
import { ICompany, IMembership, useCompanyLazyQuery } from '../../generated/graphql';
import CustomAppBar from '../Common/Layout/CustomAppBar';
import Loader from '../Common/Loader';
import CompanyDetailsTabs from './InfoTabs/Details/CompanyDetailsTabs';
import TabPanel from '../Common/Layout/TabPanel';
import CompanyAddressesTab from './InfoTabs/Addresses/CompanyAddressesTab';

const CompanyInfoWrapper: React.FunctionComponent = () => {
  const location = useLocation();
  const history = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const [company, setCompany] = useState<ICompany | null>(null);
  const [getCompany, { data, loading }] = useCompanyLazyQuery();
  const [value, setValue] = useState(0);
  const handleChange = (_: unknown, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (!company) {
      const locationElements = location.pathname.split('/').filter((e) => e);
      getCompany({ variables: { id: parseInt(locationElements[locationElements.length - 1]) } });
    }
    if (data && data.result) {
      dispatch({
        type: Actions.SetSelectedCompany,
        payload: { name: data.result.name, address_name: data.result.main_address?.name }
      });
      setCompany(data.result as ICompany);
    }
  }, [data]);

  const handleToCompaniesOverview = () => {
    dispatch({ type: Actions.ResetSelectedCompany });
    history(AuthRoutes.Companies);
  };

  const updateMembership = (mem: IMembership) => {
    setCompany({ ...(company as ICompany), membership: mem });
  };

  return (
    <Box sx={{ width: '100%' }}>
      <OverviewToolbar handleToOverview={handleToCompaniesOverview} navName={RouteNames.Companies}>
        <Box className="centralize" sx={{ gap: '5px' }}>
          <HomeWork />
          {state.selectedCompany.name || company?.name}
          <Box
            sx={{ borderRight: `1px solid ${Colors.white}`, width: '1px', height: '100%' }}
          ></Box>
          <LocationOn />
          {state.selectedCompany.address_name || company?.main_address?.name}
        </Box>
      </OverviewToolbar>
      <Box>
        <CustomAppBar
          value={value}
          handleChange={handleChange}
          tabProps={[
            { id: 'company-details', title: 'Details', icon: Info },
            { id: 'company-addresses', title: 'Addresses', icon: LocationOn }
          ]}
        />
        {company && (
          <Box>
            <TabPanel value={value} index={0}>
              <CompanyDetailsTabs company={company} updateMembershipProperty={updateMembership} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <CompanyAddressesTab companyId={parseInt(company.id)} />
            </TabPanel>
          </Box>
        )}
      </Box>
      <Loader loading={loading} />
    </Box>
  );
};

export default CompanyInfoWrapper;
